
import {Col, Row} from "react-bootstrap";

const SimpleChartBar = (props) => {
    const {title, min, max, color} = props
    let width = 0;

    const round = (value, precision) => {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }


    if(!isNaN(parseInt(min)) && !isNaN(parseInt(max))){
        width = round(parseInt(min) * 100 / parseInt(max), 1);
        if(width > 100){
            width = 100; // Super Admin
        }
    }

    const style = color ? {backgroundColor: color, width: `${width}%`} : {}

    return (
        <div className="simple-chart-bar">
            <Row>
                <Col sm={6}>
                    <span className="title">{title}: </span>
                </Col>
                <Col className="text-end">
                    <span className="min">{min}</span>/
                    <span className="max">{max}</span>
                </Col>
            </Row>
            <div className="static-horizontal">
                <div className="fill" style={style}></div>
            </div>
        </div>
    )
}

export default SimpleChartBar;